import React from 'react';
import styled from 'styled-components';
import TextComponent from '../TextComponent';
import theme from '@/styles/theme';

interface AbsentModalProps {
  onClickBePresent: () => void;
  onClose: () => void;
}

const AbsentModal = ({ onClickBePresent, onClose }: AbsentModalProps) => {
  return (
    <DimmedContainer>
      <AbsentSection>
        <TextWrapper>
          <AbsentTitle fontWeight="600" fontSize={25}>
            자리를 비우셨나요?
          </AbsentTitle>
          <AbsentDescription>
            접수된 처방전에 3회 연속 응답하지 않아 처방전 접수 기능이 자동으로
            꺼졌어요.
          </AbsentDescription>
        </TextWrapper>
        <ButtonWrapper>
          <CloseButton onClick={onClose}>닫기</CloseButton>
          <SubmitButton onClick={onClickBePresent}>
            처방전 접수 켜기
          </SubmitButton>
        </ButtonWrapper>
      </AbsentSection>
    </DimmedContainer>
  );
};

export default AbsentModal;

const DimmedContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 998;
`;
const TextWrapper = styled.div`
  padding: 40px 71.5px;
`;

const AbsentSection = styled.section`
  text-align: center;
  width: 400px;
  background-color: ${theme.DF_COLOR.WHITE};
  border-radius: 8px;
`;

const AbsentTitle = styled(TextComponent)`
  margin-bottom: 20px;
`;

const AbsentDescription = styled.p`
  display: inline-block;
  width: 270px;
  font-size: 17px;
  font-weight: 400;
  line-height: 140%;
  margin: 0;
  word-break: keep-all;
  color: ${theme.DF_COLOR.GRAY400};
`;

const ButtonWrapper = styled.div`
  display: flex;
`;

const SubmitButton = styled.button`
  border-top: 1px solid ${theme.DF_COLOR.GRAY100};
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.DF_COLOR.GREEN500};
  cursor: pointer;
  font-weight: 500;
  font-size: 17px;
  line-height: 20px;
  border-left: 0.5px solid ${theme.DF_COLOR.GRAY100};
`;

const CloseButton = styled(SubmitButton)`
  color: ${theme.DF_COLOR.BLACK};
  border-left: none;
  border-right: 0.5px solid ${theme.DF_COLOR.GRAY100};
`;
